<template>
  <div>
    <div v-show="!showPixScreen && !showSecurityCheck">
      <v-form style="width: 100%" ref="form" v-model="valid">
        <Participants
          v-if="
            (eventDetails.one_checkout === 40 ||
              eventDetails.one_checkout === 42) &&
            eventDetails.checkout_nomeacao_obrigatoria != 2 &&
            !(
              eventDetails.checkout_nomeacao_obrigatoria == 0 &&
              !$moment(
                eventDetails.data_nomeacao_ingresso,
                'YYYY-MM-DD HH:mm:ss'
              ).isBefore()
            ) &&
            !namedTickets &&
            ($route.query.order_hash ? pendingOrder && firstPayment : true)
          "
          :paymentScreen="true"
        />

        <v-row
          v-if="productsTotal !== 0"
          class="py-4"
          no-gutters
          align="center"
        >
          <span class="checkout-h6 accent--text" style="font-weight: 700">
            {{ $t("payment.buyerData") }}
          </span>
          <v-spacer></v-spacer>
          <change-buyer-data-logout v-if="loggedUser" />
        </v-row>

        <v-row v-if="productsTotal !== 0" no-gutters>
          <FormPayment />
        </v-row>

        <v-row v-if="paymentDetails && paymentDetails.split_payment" no-gutters>
          <PartialPayment />
        </v-row>

        <purchase-politics
          v-if="eventDetails?.politica_compra && productsTotal !== 0"
          :eventDetails="eventDetails"
        />

        <opt-in
          v-if="eventDetails?.checkout_opt_in && productsTotal !== 0"
          :text="eventDetails?.checkout_opt_in_texto"
          :value="eventDetails?.checkout_opt_in"
        />

        <v-row v-if="paymentDetails" no-gutters>
          <PaymentTypes
            :productsTotal="productsTotal"
            :paymentDetails="paymentDetails"
            :loading="loading"
            @purchase="$emit('purchase')"
          />
        </v-row>

        <v-row class="checkout-h4 grey--text" justify="center" no-gutters>
          <span v-html="storeDetails?.configs?.template?.termos"></span>
        </v-row>

        <v-row v-if="productsTotal === 0" class="mb-4 mt-4" no-gutters>
          <v-btn
            v-if="!loading"
            width="100%"
            rounded
            depressed
            height="40"
            color="primary"
            :disabled="!canPurchase"
            @click="$emit('purchase')"
            >{{ $t("summary.confirm") }}</v-btn
          >
        </v-row>
      </v-form>
    </div>
    <PixScreen
      v-if="showPixScreen"
      :showPixScreen="showPixScreen"
      @return="$emit('return')"
    />
    <SecurityCheck v-if="showSecurityCheck" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import FormPayment from "./Form.vue";
import PaymentTypes from "./PaymentTypes.vue";
import PixScreen from "./PixScreen.vue";
import { setOptions, bootstrap } from "vue-gtag";
import PartialPayment from "./PartialPayment.vue";
import Participants from "../../views/Participants.vue";
import PurchasePolitics from "./PurchasePolitics.vue";
import SecurityCheck from "./SecurityCheck.vue";
import ChangeBuyerDataLogout from "./ChangeBuyerDataLogout.vue";
import OptIn from "./OptIn.vue";
export default {
  props: ["showPixScreen", "loading"],

  components: {
    FormPayment,
    PaymentTypes,
    PixScreen,
    PartialPayment,
    Participants,
    PurchasePolitics,
    SecurityCheck,
    ChangeBuyerDataLogout,
    OptIn,
  },
  computed: {
    ...mapGetters([
      "paymentDetails",
      "productsTotal",
      "paymentOption",
      "canPurchase",
      "eventDetails",
      "buyer",
      "orderDetails",
      "cartProducts",
      "pdv",
      "nominationValid",
      "storeDetails",
      "showSecurityCheck",
      "loggedUser",
      "namedTickets",
      "pendingOrder",
      "firstPayment",
    ]),
    googleAnalytics() {
      return this.eventDetails?.integracoes_publicas?.find(
        (i) => i.tipo === "google_analytics"
      )?.credenciais?.token;
    },
  },
  data() {
    return {
      valid: false,
      optIn: false,
    };
  },
  mounted() {
    if (this.googleAnalytics) {
      let options = {};
      options = {
        config: {
          id: `${
            this.isLetter(String(this.googleAnalytics).charAt(0)) ? "" : "UA-"
          }${this.googleAnalytics}`,
        },
      };
      setOptions(options);

      bootstrap();
    }
  },
  watch: {
    valid(v) {
      this.validateCanPurchase(v, this.nominationValid);
    },
    nominationValid(v) {
      this.validateCanPurchase(this.valid, v);
    },
  },
  methods: {
    validateCanPurchase(buyerForm, nomination) {
      let canPurchase = false;
      let nominationObrigatory =
        this.eventDetails?.checkout_nomeacao_obrigatoria &&
        this.eventDetails?.checkout_nomeacao_obrigatoria != 2 &&
        (this.eventDetails?.one_checkout === 40 ||
          this.eventDetails?.one_checkout === 42);

      if (
        nominationObrigatory &&
        (!this.$route.query.order_hash || !this.namedTickets)
      )
        canPurchase = buyerForm && nomination;
      else canPurchase = !!buyerForm;

      if (!this.firstPayment && this.$route.query.order_hash)
        canPurchase = !!buyerForm;

      this.$store.commit("SET_CAN_PURCHASE", canPurchase);
    },

    isLetter(str) {
      return /[a-zA-Z]/.test(str);
    },
  },
};
</script>
